<template>
  <li class="splide__slide">
    <a :href="result.url" class="card">
      <div class="inner">
        <div class="logo" v-if="result?.images?.clientLogo">
          <img
            :src="result?.images?.clientLogo?.url.toCropUrl(190, 90)"
            :alt="result?.images?.clientLogo?.altText"
          />
        </div>
        <div class="tag" v-if="result?.additionalFields.previewTag">
          <div class="color"></div>
          {{ result?.additionalFields.previewTag }}
        </div>
        <h4 class="heading" v-if="result?.pageTitle">
          {{ result?.pageTitle }}
        </h4>
        <div class="arrow">
          <svg
            role="img"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="12"
            fill="#fff"
          >
            <path d="M10 5h2v2h-2zM5 5h2v2H5zM0 5h2v2H0z" />
            <path
              d="M14.795 10.123l1.522 1.522 3.804-3.804 1.522-1.522h0l-1.522-1.522h-.001L16.316.992l-1.522 1.522 3.805 3.805-3.804 3.804z"
            />
          </svg>
        </div>
      </div>

      <div class="preview">
        <picture>
          <source
            :srcset="
              result?.images?.previewImage?.url.toCropUrl(400, 464) ||
                defaultSiteImageUrl.toCropUrl(400, 464)
            "
            media="(min-width: 0px)"
          />
          <img
            :src="
              result?.images?.previewImage?.url.toCropUrl(400, 464) ||
                defaultSiteImageUrl.toCropUrl(400, 464)
            "
            :alt="result?.images?.previewImage?.altText"
          />
        </picture>
      </div>
    </a>
  </li>
</template>
<script lang="ts">
import { defineComponent, PropType } from "vue";
import { ISiteSearchResultItem } from "../../clients/search/src/models";

export default defineComponent({
  props: {
    result: {
      type: Object as PropType<ISiteSearchResultItem>,
      required: true,
      default: (): ISiteSearchResultItem => { return {} }
    },
    language: {
      type: String,
      required: false,
      default: ""
    },
    defaultSiteImageUrl: {
      type: String,
      required: true,
      default: ""
    }
  },
  computed: {
    resultUrl() {
      const urlParts: string[] = [window.location.origin, this.result?.url];

      return urlParts
        .map((url) => (url ? url.replace(/^\/+|\/+$/g, "") : ""))
        .join("/");
    }
  }
});
</script>
